<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2>{{ message }}</h2>
        <br>
        <div v-if="failure">
          <c-button :onClick="onConnect" variant="transparent" :keepLoading="true">
            <img class="logo" src="../../public/github.png" width="300px">
          </c-button>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { onLogin } from '../vue-apollo';

  export default {
    name: 'Authorize',
    components: { CButton },
    props: {

    },
    data() {
      return {
        message: '',
        failure: false,
        code: null,
        state: null,
      }
    },
    async created() {
      if (this.$route.query.error) {
        this.failure = true
        const error = this.$route.query.error
        if (error === 'access_denied') {
          this.message = 'You did not authorize Github to connect to your account. Please try again'
        } else {
          this.message = 'There has been an error connecting to Github. Please try again'
        }
      } else if (this.$route.query.code && this.$route.query.state) {
        this.code = this.$route.query.code
        this.state = this.$route.query.state

        await this.exchangeToken()
      }
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      async onConnect(event) {
        const response = await this.$http.get(process.env.VUE_APP_API_BASE_URL + `/github/auth`)

        if (response && response.body && response.body.authUrlWeb) {
          window.location.href = response.body.authUrlWeb;
        } else {
          throw(new Error('Could not redirect to Github log in page'))
        }
      },
      async exchangeToken() {
        this.message = 'Authorizing...'

        try {
          const body = {
            code: this.code,
            state: this.state
          }
          const response = await this.$http.post(process.env.VUE_APP_API_BASE_URL + "/github/auth", body)

          if (response.body.user.email) {
            this.message = ''
            await this.getUser()

            if (this.$route.query.id) {
              this.$router.push({ name: 'Deployment', params: { id: this.$route.query.id }});
            } else {
              this.$router.push({ name: 'Deploy' });
            }
          }
        } catch(e) {
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }
      },
      async getUser() {
        const result = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/auth");
        if (result && result.body && result.body.user) {
          await onLogin.apply(this, [this.$apollo.provider.defaultClient, result.body.user])
        }
      },
    }
  }
</script>

<style scoped>

</style>
